var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoWeather(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    style: {
      enableBackground: "new 0 0 90 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#4F4E50;stroke-width:2.4318;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.1,42.9c-0.2-0.2-0.9,0.2-0.9-0.7v-1.3c0-7.9-6.4-14.3-14.3-14.3c-3.3,0-6.2,1.1-8.6,2.9 c-0.4,0.2-0.7,0.2-0.9-0.2c-3.5-5-9.2-8.3-15.6-8.3c-10.5,0-19.1,8.4-19.1,19.1c0,0.7,0,1.3,0.2,2c0,0.5-0.6,0.7-0.7,0.7H15 c-7.3,0-13.2,6.1-13,13.4c0.2,7.1,6.4,12.7,13.6,12.7h58.9c7.2,0,13.4-5.5,13.6-12.7C88.2,49.3,82.9,43.6,76.1,42.9z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoWeather);
export default __webpack_public_path__ + "static/media/ico_weather.3dd5ed1b61323e8f9cd13b182ee0a3ed.svg";
export { ForwardRef as ReactComponent };